import { TextField, TextFieldProps } from "@mui/material";
import { useField } from "@unform/core"
import { useEffect, useState } from "react";

type TVTextFieldProps = TextFieldProps & {
    name: string;
    maxLength?: number,
    type?: string
}

const dataHoje = new Date();
//Componentes Unform
export const VTextFieldDatas: React.FC<TVTextFieldProps> = ({ name, maxLength, type, ...rest }) => {
    const { fieldName, registerField, defaultValue, error, clearError } = useField(name);
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        registerField({
            name: fieldName,
            getValue: () => value,
            setValue: (e, newValue) => {
                if (newValue === undefined) {
                    return null;
                }
                newValue = newValue !== null ? newValue.split(".")[0] : newValue;
                if (fieldName === "dtNascimento") {
                    newValue = newValue.split("T")[0];
                }
                if (type === "datetime-local" && newValue !== null && newValue.toString() === "0001-01-01T00:00:00") {
                    newValue = null;
                }
                setValue(newValue);
            },

        })
    }, [registerField, fieldName, value])

    return (
        <TextField
            {...rest}
            size={"small"}
            error={!!error}
            helperText={error}
            defaultValue={defaultValue}
            onKeyDown={(e) => { error && clearError(); rest.onKeyDown?.(e); }}
            type={type}
            value={value}
            onChange={(e) => { setValue(e.target.value); rest.onChange?.(e); }}

        />
    );
};